export default __webpack_public_path__ + "static/media/wordCloud.e46cc171.png";